import {useEffect, useState} from 'react';
import {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';
import {Timer} from '@gongxigames/framework/core/fragments/update/Timer';

export const useTimer = (
    callback: () => void,
    updateManager: UpdateManager,
    duration: number,
    autostart = true,
    retrigger?: any[]
): (Timer | undefined)[] => {
    const [timer, setTimer] = useState<Timer>();

    useEffect(() => {
        timer?.stop();

        const newTimer = updateManager.addTimer(callback, duration, autostart);

        setTimer(newTimer);

        return () => {
            newTimer.stop();
        };
    }, retrigger);

    return [timer];
};
